import { makeAutoObservable } from "mobx"
import ChecklistItem from "./ChecklistItem"
import DraftShareVersion from "./DraftShareVersion"

export default class ActionDraft {

  constructor(actionDraft = {}) {
    this.id = actionDraft.id
    this.draft_status = actionDraft.draft_status || 'draft'
    this.due_date = actionDraft.due_date
    this.enabled_fields = actionDraft.enabled_fields || {}
    this.checklist_items = actionDraft.checklist_items?.map(item => new ChecklistItem(item)) || []
    this.versions = actionDraft.versions?.map(version => new DraftShareVersion(version)) || []

    makeAutoObservable(this)
  }

  fieldEnabled(field) {
    return !!this.enabled_fields[field]
  }

  get latestVersion() {
    return this.versions[this.versions.length - 1] || null
  }

  // The version currently being worked on, if any save/submit hasn't
  // finished yet - same concept as DraftShareActionDraft's, reused here so
  // the PM's "submit on behalf" form and the influencer's own form share
  // one data shape.
  get workingVersion() {
    const latest = this.latestVersion
    return latest && !latest.isSubmitted ? latest : null
  }

  get latestSubmittedVersion() {
    const submitted = this.versions.filter(v => v.isSubmitted)
    return submitted[submitted.length - 1] || null
  }

  addVersion(version) {
    const existing = this.versions.find(v => v.id === version.id)
    if (existing) {
      Object.assign(existing, version)
    } else {
      this.versions.push(version)
    }
  }
}
